<template>
    <div class="study-instructions-page">
        <div class="container-fluid mt-1">
            <div class="row">
                <div class="col-xl-8 mb-5 mb-xl-0">
                    <card header-classes="bg-transparent" body-classes="bg-transparent p-0">
                        <div slot="header" class="row align-items-center">
                            <div class="col-sm-6">
                                <h6 class="text-uppercase ls-1 mb-1">Petunjuk Belajar</h6>
                            </div>
                            <div v-if="silabus" class="col-sm-6 text-right">
                                <a v-if="silabus.file_type=='pdf'&&silabus.file_path!='-'" :href="silabus.download_link" target="_blank" class="icon-clicked p-1">
                                    <b-button variant="info" size="sm" ><i class="fa fa-download" aria-hidden="true"></i> Download</b-button>
                                </a>
                                <b-button v-if="silabus.is_admin" variant="primary" size="sm" @click="showStudiInstructionsFormModal"><i class="fa fa-edit" aria-hidden="true"></i> Edit</b-button>
                            </div>
                            <div v-else class="col-sm-6 text-right">
                                <b-button v-if="user.type=='admin' || user.type=='tutor'" variant="primary" size="sm" @click="showStudiInstructionsFormModal"><i class="fa fa-edit" aria-hidden="true"></i> Edit</b-button>
                            </div>
                        </div>
                        <div v-if="silabus" class="silabus p-2">
                            <div v-if="silabus.is_file==1">
                                <div v-if="silabus.file_type=='video'" class="card-footer">
                                    <b-button variant="primary" size="sm" @click="openVideo"><i class="fa fa-video" aria-hidden="true"></i> Play</b-button>
                                </div>
                                <div v-else style="text-align:center">
                                    <iframe :src="silabus.view_link" width="100%" height="500"></iframe>
                                </div>
                            </div>
                            <div v-else>
                                <div class="silabus p-4" v-html="silabus.description"></div>
                            </div>
                        </div>
                        <div v-else class="p-2 text-center text-muted">
                            <i class="fa fa-graduation-cap text-custom-primary" aria-hidden="true"></i>
                            <p>
                                Saat ini belum ada petunjuk belajar
                            </p>
                        </div>
                    </card>
                </div>
                <div class="col-xl-4">
                    <div class="card" >
                        <div class="card-header row align-items-center bg-transparent">
                            <div class="d-flex justify-content-between" style="align-items: center;">
                                <div class="col">
                                    <h6 class="text-uppercase ls-1 mb-1">Info</h6>
                                </div>
                                <div >
                                    <b-dropdown id="dropdown-1" right text="Kembali" size="sm" class="m-md-2">
                                        <b-dropdown-item ><router-link :to="{ name: 'class-detail', params:{ classId: subjectDetail.class_id} }" class="icon-clicked p-1"><i class="clr-red fa fa-arrow-left" aria-hidden="true"></i> Halaman Kelas</router-link></b-dropdown-item>
                                    </b-dropdown>   
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="identity px-2">
                                <p class="line-with-icon"><i class="fa fa-user" aria-hidden="true"></i>{{subjectDetail.user_name}}</p>
                                <p class="line-with-icon"><i class="fa fa-user" aria-hidden="true"></i>{{subjectDetail.user_status}}</p>
                                <p class="line-with-icon"><i class="fa fa-bookmark" aria-hidden="true"></i>{{subjectDetail.class_name}}</p>
                                <p class="line-with-icon"><i class="fa fa-book" aria-hidden="true"></i>{{subjectDetail.name}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal
			ref="study-instruction-modal"
			class="study-instruction-modal"
			size="lg"
            title="Edit Petunjuk Belajar"
            @show="resetStudiInstructionsForm"
            @hidden="resetStudiInstructionsForm"
			hide-footer
			no-close-on-backdrop
		>
            <studi-instructions-form
                :subjectId="this.$route.params.subjectId"
                :silabusId="silabus ?silabus.id : null"
                :attributes="silabus"
            ></studi-instructions-form>
		</b-modal>
        <b-modal
			ref="open-video"
			class="open-video"
			size="lg"
            title="Petunjuk Belajar"
			hide-footer
			no-close-on-backdrop
		>
            <div>
                <video-embed :src="silabus.file_path"></video-embed>
            </div>
		</b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { EventBus } from '@/eventBus.js'
	import StudiInstructionsForm from "../../../components/Main/StudyInstructions/StudiInstructionForm";
    export default {
        components: {
            StudiInstructionsForm
        },
        data() {
            return {
            }
        },
        computed: {
            ...mapGetters({
                user: 'getUser',
                subjectDetail: 'getSubjectDetail',
                silabus: 'getSilabus',
            })
        },
        watch: {
        },
        methods: {
            showStudiInstructionsFormModal() {
                this.$refs['study-instruction-modal'].show()
            },
            hideStudiInstructionsFormModal() {
                this.$refs['study-instruction-modal'].hide()
            },
            resetStudiInstructionsForm() {
                EventBus.$emit('resetStudiInstructionsForm', true)
            },
            openVideo(){
                this.$refs['open-video'].show()
            },
			async getSubjectDetail() {
                let subjectId = this.$route.params.subjectId
				await this.$store.dispatch('getSubjectDetail', { subjectId })
					.then(() => {
					})
					.catch((err)=> {
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
			},
			async getSilabus() {
                let subjectId = this.$route.params.subjectId
				await this.$store.dispatch('getSilabus', { subjectId })
					.then(() => {
					})
					.catch((err)=> {
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
			},
        },
        created() {
            this.getSilabus()
            this.getSubjectDetail()
			EventBus.$on('hideStudiInstructionsFormModal', (val) => {
				if (val) {
					this.hideStudiInstructionsFormModal()
				}
			})
        }
    }
</script>
<style lang="css" scoped>
.btn-primary {
    color: #fff;
    background-color: #ca062a;
    border-color: #ca062a;
}
.btn-primary:hover, .btn-primary:not(:disabled):not(.disabled):active, .btn-primary:focus {
    color: #fff;
    background-color: #ca062a;
    border-color: #ca062a;
    -webkit-box-shadow: unset;
    box-shadow: unset;
}
</style>